import React from 'react';
import UniversalAddItemForm from '../../shared/UniversalAddItemForm';

const AddItemToCommandeForm = ({ refCommande, onSuccess }) => {
  return (
    <UniversalAddItemForm
      refField="REF_CA"
      refValue={refCommande}
      onSuccess={onSuccess}
      priceType="purchase"
      enableBatch={true}
      allowDuplicateArticles={true}
      useArticleList={false}
      submitButtonText="Add all to Commande"
    />
  );
};

export default AddItemToCommandeForm;
